module.exports = __webpack_public_path__ + "static/planning-an-exhibition-81865f849072e0dbb2f212249b878551.pdf";